import {getDefaultActivityType} from '../../core/activities/get-default-activity-type';
import {defaultDurationOption} from '../../timeline/creator/consts';

import type {CoreEntityPageState, TabOption} from './types';

export const TAB_ACTIVITY = 'activity';
export const TAB_NOTE = 'note';
export const TAB_EMAIL = 'email';
export const TAB_TEXT = 'text';
export const TAB_CALL = 'call';

// Used to properly anchor popover to the on-scroll mini action bar call button
export const TAB_CALL_MINI_FIXED_ANCHOR = 'call-fixed';

export function isFormTabSelected(tab: TabOption | null): boolean {
    return tab !== null && (tab === TAB_NOTE || tab === TAB_ACTIVITY);
}

export const INITIAL_CORE_ENTITY_PAGE_STATE: CoreEntityPageState = {
    creatorForm: {
        noteHtmlValue: '',
        notePlaintextValue: '',
        isActive: false,
        activityTypeId: getDefaultActivityType(),
        durationMinutes: defaultDurationOption.value,
        pinNote: false,
        isTranscribing: false,
    },
    actionBarTab: TAB_ACTIVITY,
};
